import { render, staticRenderFns } from "./ExpandCollapseButton.vue?vue&type=template&id=15313322&scoped=true&"
import script from "./ExpandCollapseButton.vue?vue&type=script&lang=js&"
export * from "./ExpandCollapseButton.vue?vue&type=script&lang=js&"
import style0 from "./ExpandCollapseButton.vue?vue&type=style&index=0&id=15313322&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15313322",
  null
  
)

export default component.exports